<template>
  <!--  서브페이지  -->
  <div id="sub_area">
    <!--비주얼 영역-->

    <div class="sub_visual">
      <div class="tit_area">
        <h2 class="tit">{{ title }}</h2>
      </div>
      <img v-if="title == '페럼클럽'" :src="require('./../../assets/img/sub/SUB_02_01.png')" alt="BG" />
      <img v-if="title == 'MRO'" :src="require('./../../assets/img/sub/SUB_02_02.png')" alt="BG" />
      <img v-if="title == '페럼홀'" :src="require('./../../assets/img/sub/SUB_02_03.png')" alt="BG" />
    </div>

    <div class="navigation_area">
      <div class="navigation">
        <router-link to="/" class="i_home">
          <span>HOME</span>
        </router-link>

        <div
          class="item"
          :class="{ on: mainMenuShow }"
          @mouseover="mainMenuShow = true"
          @mouseleave="mainMenuShow = false"
        >
          <a>{{ title }}</a>
          <div>
            <router-link
              active-class="on"
              tag="a"
              to="/Biz/Club"
              @click.native="mainMenuShow = false"
            >페럼클럽</router-link>
            <router-link
              active-class="on"
              tag="a"
              to="/Biz/MRO"
              @click.native="mainMenuShow = false"
            >MRO</router-link>
            <router-link
              active-class="on"
              tag="a"
              to="/Biz/Tower"
              @click.native="mainMenuShow = false"
            >페럼홀</router-link>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    mainMenuShow: false,
    message: "BizMain.vue",
    title: ""
  }),
  methods: {
    titleChange(urlPath) {
      switch (urlPath) {
        case "/Biz/Club":
          {
            this.title = "페럼클럽";
          }
          break;
        case "/Biz/Tower":
        case "/Biz/Reserve":
        case "/Biz/Reserve/ReservePopup":
          {
            this.title = "페럼홀";
          }
          break;
        case "/Biz/MRO":
          {
            this.title = "MRO";
          }
          break;
      }
    }
  },
  computed: {},
  watch: {
    $route(to, from) {
      this.titleChange(to.path);
    }
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
    this.titleChange(this.$route.path);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/BizMain.vue